import './SideMenu.css'
import { useLocation, useNavigate } from 'react-router-dom'
import Logo from '../../img/final_logo.png'
import CryptoJS from 'crypto-js';
function SideMenu() {
    const navigate = useNavigate();
    const { pathname, state } = useLocation()

    const handleLinkClick = (e, link) => {
        e.preventDefault();
        if (link === '/') {
            // Logout - clear session
            sessionStorage.removeItem('ID_CardAdmin_user');
            sessionStorage.removeItem('ID_CardAdmin_user_auth');
            sessionStorage.removeItem('ID_CardAdmin_user_role');
            navigate('/login');
            return;
        }
        navigate(link);
    }

    // Check if user is vendor
    const isVendor = sessionStorage.getItem('ID_CardAdmin_user_role') === 'vendor';

    const sideMenuTabsArr = [
        {
            heading: 'ID Cards',
            link: '/idcards',
            activeRoutes: ['/idcards', `/idcards/${state?.id}`, '/idcards/create', '/download-by-excel'],
            showForVendor: false
        },
        {
            heading: 'Download by Date',
            link: '/download-by-date',
            activeRoutes: ['/download-by-date'],
            showForVendor: false
        },
        {
            heading: 'Download by School',
            link: '/download-by-school',
            activeRoutes: ['/download-by-school'],
            showForVendor: false
        },
        {
            heading: 'Download by Class',
            link: '/download-by-class',
            activeRoutes: ['/download-by-class'],
            showForVendor: false
        },
        {
            heading: 'Users',
            link: '/users',
            activeRoutes: ['/users'],
            showForVendor: false
        },
        {
            heading: isVendor ? 'Schools under vendor' : 'Schools',
            link: isVendor ? '/vendor-schools' : '/schools',
            activeRoutes: ['/schools', `/schools/${state?.schoolid}`, `/schools/class/${state?.classid}`],
            showForVendor: true
        },
        {
            heading: 'Logout',
            link: '/',
            activeRoutes: ['/'],
            showForVendor: true
        },
    ]

    // Filter tabs based on vendor status
    const filteredTabs = isVendor 
        ? sideMenuTabsArr.filter(tab => tab.showForVendor === true)
        : sideMenuTabsArr;

    // Skip auth check for vendors - they should see the menu
    if (!isVendor && sessionStorage?.getItem('ID_CardAdmin_user_auth')) {
        const bytes = CryptoJS.AES.decrypt(sessionStorage?.getItem('ID_CardAdmin_user_auth'), process.env.REACT_APP_CRYPTO_JS_SECRET);
        const decrypt = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        if (decrypt) return;
    }

    if (pathname == '/login') return;
    return (
        <div id='sidemenu'>
            <section className='sidemenu_cont'>
                {/* <h2>Logo</h2> */}
                <div className='logo_container'>
                <img className='sidemenu_logo' src={Logo}></img>

                </div>
                <div className="sidemenu_sec1">
                    {filteredTabs?.map((t, i) => {
                        let isActive = false;
                        if (isVendor && t.heading === 'Schools under vendor') {
                            // For vendors, check if pathname starts with /vendor-schools
                            isActive = pathname.startsWith('/vendor-schools');
                        } else {
                            isActive = t.activeRoutes.includes(pathname);
                        }
                        return (
                            <div onClick={e => handleLinkClick(e, t.link)} key={i} className={`sidemenu_btn ${isActive ? 'sidemenu_btn_active' : ''}`} >
                                {t.heading}
                            </div>
                        );
                    })}
                </div>
            </section>
        </div>
    )
}

export default SideMenu
